'use client';

import { PageLoader } from '@crehana/compass.ui/v2';

import { useSetupTranslations } from './hooks/use-setup-translations';

export const I18nSetupPageTranslations: React.FC<
  React.PropsWithChildren<{ namespaces: string[] }>
> = ({ children, namespaces }) => {
  const { loading } = useSetupTranslations({
    namespaces,
  });

  if (loading) {
    return <PageLoader />;
  }

  return <>{children}</>;
};
